<div class="hydra-img-container">
    <img
        src="../../../assets/images/hydra.png"
        width="400"
        height="400"
        alt=""
    />
    <p class="title">YOU ARE NOT AUTHORIZED</p>
</div>
<div class="instructions">
    <p>
        Please contact your manager to make sure you have the right access
        rights
    </p>
    <p>
        Updating accessRights can take up to 5 minutes so please be patient :)
    </p>
</div>
<mat-card class="error-container">
    <mat-card-header class="header">
        <mat-card-title> Error Code </mat-card-title>
        <button (click)="updateUser()" mat-icon-button matTooltip="Retry">
            <mat-icon>refresh</mat-icon>
        </button>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content>
        <pre>
            {{ lastError() }}
        </pre>
    </mat-card-content>
</mat-card>
